import React from "react";
import { useEffect, useState, useRef } from "react";
import "./style.css";
import { BouncingLoader } from "../../pure-components/Loader";
import API from "../../services/api";
import { Link } from "react-router-dom";
import defaultImage from "../../assets/default_music.png";
import { toast } from "react-toastify";
import { ErrorToast } from "../../pure-components/CustomToast";
import CatalogAlbum from "./catalog-album";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import HarvestService from "../../services/harvestService";
import MediaTile from "./media-tile";
import Helper from "../../services/helper";

const Catalog = (props) => {
  const placeholderColor = { 
      backgroundColor: "rgb(var(--bg))", 
      color: "rgb(var(--text))" 
  }
  const listRef = useRef(null);
  const history=useHistory()
  const [searchText,setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [catalogList, setCatalogList] = useState([]);
  const [catalogs, setCatalogs] = useState([]);
  const pageId = "catalogs"
  const lastClickedKey = "lastClickedCatalogId";
  
  // Scroll to last clicked item after list loads
  
  const scrollToItem = (id) => {
    const el = document.getElementById(`${id}`);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  };
  useEffect(() => {
    if (catalogs.length === 0) return;

    const lastClickedId = sessionStorage.getItem(lastClickedKey);
    if (!lastClickedId) return;

    // wait for images
    const container = listRef.current;
    const images = container.querySelectorAll("img");

    let loadedCount = 0;

    if (images.length === 0) {
      scrollToItem(lastClickedId);
      return;
    }

    images.forEach((img) => {
      if (img.complete) {
        loadedCount++;
        if (loadedCount === images.length) scrollToItem(lastClickedId);
      } else {
        img.onload = () => {
          loadedCount++;
          if (loadedCount === images.length) scrollToItem(lastClickedId);
        };
        img.onerror = () => {
          loadedCount++;
          if (loadedCount === images.length) scrollToItem(lastClickedId);
        };
      }
    });
  }, [catalogs]);

  useEffect(() => {
      (async() => {
        if(!window.location.pathname.includes("album"))
          await loadCatalogList()
      })()
    
  }, [])

  const loadCatalogList = async() => {
    setLoading(true);
    const reqObj = {
        refUrl : `/getlibraries/{memberToken}`, 
        method : 'get',
        headers : {
            "Accept" : "application/json",
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
        }
      };
    await HarvestService.loadHarvestData(reqObj).then((resp) => {
      // console.log("Catalogs : ", resp);
      const tempData = resp.Libraries;
      if(tempData?.length > 0)
        tempData.sort((a, b) => {
          return a.Name.localeCompare(b.Name)
        })
      setCatalogList(tempData);
      setCatalogs(tempData);
    }).catch((err) => {
      console.log("Catalogs Loading Error : ", err);
      toast(({ closeToast }) => <ErrorToast message={"Catalog list loading Error."} />);
    }).finally(() => {
      setLoading(false);
    })
  }
  const handleSearch = async(e) => {
    
    if(e.key === 'Enter' && !loading){
      if(searchText?.length > 0){
        const filteredList = catalogList?.filter((elem) => elem.Name?.toLowerCase().includes(searchText.toLowerCase()))
        setCatalogs(filteredList)
      }else{
        setCatalogs(catalogList);
      }
    }
  };

  const loadCatalogAlbums = (catalogData) => {
    history.push(`catalog/albums/${catalogData.ID}`, {catalogData : catalogData})
  }
  return (
    <>
    {!window.location.pathname.includes("/album") ?
    <div 
      className="sm:flex sm:flex-col sm:w-full lg:mx-auto p-5 rounded-2xl"
      style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))", minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll"}}
    >
      <div className="w-full flex mb-1">     
        <input id="catalog_search_box" className="w-full  p-1 pl-2 search-box search-icon rounded-full outline-none text-xs lg:text-base text-gray-600"
          onChange={event => { setSearchText(event.target.value) }}
          onKeyDown={handleSearch}
          placeholder="Search Label"
          disabled={loading}
          value={searchText}
          style={{"font-size": "13px", "height" : "36px"}} />
      </div>
      
      <div className="border-t my-2"></div>
      
      <div className="w-full">
        {loading && (
          <div className="w-full">
            <BouncingLoader />
          </div>
        )}
        
        {!loading && !(catalogs?.length > 0) ? (
          <div className="text-xl text-center text-red-500 my-5">
            No Catalog Found
          </div>
        ) : (
          <div ref={listRef} 
          style={{overflowY: "auto", backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))" }}>
            <ul 
            className="bg-white grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-2 sm:gap-2 md:gap-2 mt-2"
            style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))" }}
            >
            {catalogs?.map((elem) => (
              <li id={`${elem.ID}`} key={elem?.ID} className="m-1" >
              <Link to={`/catalog/albums/${elem?.ID}`} onClick={() => {sessionStorage.setItem(lastClickedKey, elem?.ID)}}>
                {/* <div className="music-tile" key={elem?.ID}>
                  <div className="image-container">
                    {elem != null && elem?.LibraryLogoUrl != null ? (
                      <img
                        src={elem?.LibraryLogoUrl || defaultImage}
                        alt=""
                        onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
                        className="sm:flex border sm:cursor-pointer w-full h-auto object-cover"
                        loading="lazy"
                      />
                    ) : (
                      <img
                        src={defaultImage}
                        alt=""
                        className="sm:flex border-b sm:cursor-pointer music-image justify-center align-middle w-full h-auto"
                        loading="lazy"
                      />
                    )}
                    <span className="play_icon" title="Play"></span>
                  </div>
                  <div className="p-2">
                    <p className="text-sm"><b>{elem?.Name}</b></p>
                    {elem.Detail?.length > 0 &&
                      <p className="text-sm font-light text-left description line-clamp-2"
                        title={elem.Detail}
                      >
                        {elem.Detail || elem?.Name}
                      </p>
                    }
                  </div>
                </div> */}
                <MediaTile
                  style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))" }}
                  image={elem?.LibraryLogoUrl || defaultImage}
                  title={elem?.Name}
                  code=""
                  description={elem?.Detail || elem?.Name}
                  id={elem.ID}
                />
              </Link>
              </li>
            ))}
            </ul>
          </div>
        )}
      </div>
    </div>
     : <div>
        <CatalogAlbum />
      </div>
    }
    </>
  );
};

export default Catalog;